
































































































import { Component, Vue, Emit, Prop } from 'nuxt-property-decorator'
import SearchResults from '~/components/pois/SearchResults.vue'
import Input from '~/components/shared/inputs/TextInput.vue'
import ProjectConfig from '~/models/projectConfig'

@Component({
  components: {
    Input,
    SearchResults,
  },
})
export default class CategoriesFilter extends Vue {
  @Prop({ default: (): Array<string> => [] }) categories: Array<string>
  @Prop({ default: (): Array<any> => [] }) amenities: Array<any>
  @Prop({ default: (): any => {} }) projectConfig: ProjectConfig

  maxLenght: number = 20
  categoryFilter: string = ''
  searchText: string = ''

  categoriesRef: any = null
  isLeftCaretVisible: boolean = true
  isRightCaretVisible: boolean = true

  mounted() {
    this.categoriesRef = this.$refs.categories
    this.getCaretsVisibility()
  }

  setCategory(category: string) {
    if (this.categoryFilter === category) {
      this.categoryFilter = ''
    } else {
      this.categoryFilter = category
    }
    this.performSearch()
  }

  handleInput(event: any) {
    event.preventDefault()
    this.searchText = event.target.value
    this.performSearch()
  }

  clearSearchField() {
    this.searchText = ''
    this.performSearch()
  }

  @Emit('searchTerm')
  performSearch() {
    return { searchText: this.searchText, category: this.categoryFilter }
  }

  @Emit('onMouseLeave')
  onMouseLeave(result: any) {
    return result
  }

  @Emit('onMouseEnter')
  onMouseEnter(result: any) {
    return result
  }

  getCaretsVisibility() {
    const isContentOverflowingTheBox =
      this.categoriesRef?.scrollWidth > this.categoriesRef?.clientWidth

    this.isLeftCaretVisible =
      isContentOverflowingTheBox && this.categoriesRef.scrollLeft > 0

    this.isRightCaretVisible =
      isContentOverflowingTheBox &&
      this.categoriesRef.scrollLeft + this.categoriesRef?.clientWidth <
        this.categoriesRef?.scrollWidth
  }

  moveToRigth() {
    this.categoriesRef.scrollLeft += 40
    this.getCaretsVisibility()
  }

  moveToLeft() {
    this.categoriesRef.scrollLeft -= 40
    this.getCaretsVisibility()
  }
}
